import {useCallback, useState} from 'react';
import type {Job} from '@cp/model';
import {jobCreateQuestionValidation} from '../../api/callable/jobs';

export function useCreateQuestionValidationJob() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);

  /**
   * Create a question validation job
   * @param moduleId - The module ID to validate questions for
   * @param topics - Optional array of topics to validate (if not provided, validates all topics)
   * @param difficulties - Optional array of difficulties to validate (if not provided, validates all difficulties)
   * @returns The created job document
   */
  const createQuestionValidationJob = useCallback(
    async (moduleId: string, topics?: string[], difficulties?: number[]): Promise<Job> => {
      setLoading(true);
      setError(undefined);
      try {
        return await jobCreateQuestionValidation({moduleId, topics, difficulties});
      } catch (err) {
        const e = err instanceof Error ? err : new Error(String(err));
        setError(e);
        throw e;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return {
    createQuestionValidationJob,
    loading,
    error,
  };
}
